import { defaultDateRange } from "@repo/app-types/entities/dateRange";
import type {
  PlaybookCriterionNode,
  PlaybookId,
} from "@repo/app-types/entities/playbook";
import type { TeammateId } from "@repo/app-types/entities/teammate";
import { useNow } from "@repo/ui/timestamps/timestampContext";
import type { FC } from "react";
import {
  usePlaybookCriterionTopExamplesQuery,
  usePlaybookGlobalAverageScorePerCriteriaQuery,
} from "../../api/entities/performancePlaybook.js";
import { buildPlaybookScope } from "../filters/buildFilterQueryArgs.js";
import { CriterionTeamExamplesView } from "./criterionTeamExamples.js";

interface CriterionTeamExamplesContainerProps {
  playbookId: PlaybookId;
  teammateId: TeammateId;
  criterion: PlaybookCriterionNode;
}

export const CriterionTeamExamplesContainer: FC<
  CriterionTeamExamplesContainerProps
> = (props) => {
  const { playbookId, teammateId, criterion } = props;

  const now = useNow();

  const {
    data: topExamples,
    isLoading,
    isError,
  } = usePlaybookCriterionTopExamplesQuery({
    playbookId,
    criterionId: criterion.id,
    excludeTeammateId: teammateId,
  });

  // Get the company-wide median for gapBar display. The global-average query
  // already returns the median per criterion, so we source it from there over
  // the default (company-wide, last 90 days) window.
  const { data: globalAverageScorePerCriteria } =
    usePlaybookGlobalAverageScorePerCriteriaQuery({
      scope: buildPlaybookScope(now, playbookId, defaultDateRange),
      filters: [],
    });
  const selectedCriterionMedianScore =
    globalAverageScorePerCriteria?.find(
      (item) => item.criteria_node_id === criterion.id,
    )?.global_median_score ?? undefined;

  return (
    <CriterionTeamExamplesView
      playbookId={playbookId}
      criterion={criterion}
      medianAverageScore={selectedCriterionMedianScore}
      sortedGradings={topExamples ?? []}
      isLoading={isLoading}
      isError={isError}
    />
  );
};
